import { FileText, Download, Building2, Users, MapPin, Calendar, Search, Dice1 as License, ChevronDown, Handshake, MonitorUp, CircuitBoard, FilePlus2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { GrDocker } from "react-icons/gr";
import Table from '../../components/common/table/Table';
import { getOrganisationDetails, getOrganisationEpmployeeList } from '../../Redux/Actions/adminScreenActions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GenerateLicense, getListLicenses } from '../../API/super-admin/LicenseApi';
import { getPartnerEmployees, makeEmployeeAdmin } from '../../API/super-admin/Super-admin-api';

const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case "active":
      return "bg-green-100 text-green-800"
    case "expired":
      return "bg-red-100 text-red-800"
    case "pending":
      return "bg-yellow-100 text-yellow-800"
    default:
      return "bg-gray-100 text-gray-800"
  }
}

const OrganisationDetails=()=> {
  let dispatch = useDispatch()
  const { id } = useParams();

  const { userInfo } = useSelector((state) => state.userLogin);
  const token = userInfo?.token
  const isCompanyAdmin = userInfo?.super_admin


  const [searchTerm, setSearchTerm] = useState('');
  const [currentView, setCurrentView] = useState('employees');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [licenses,setLicenses] = useState([]);
  const [employeeList,setEmployeeList] = useState([]);

  const { getOrganisationDetailsData } = useSelector((state) => state.getOrganisationDetailsData)
  const { getOrganisationEmployeesData } = useSelector((state) => state.getOrganisationEmployees)


  useEffect(() => {
    dispatch(getOrganisationDetails(id))
    dispatch(getOrganisationEpmployeeList(id))
  }, [id])

const getEmployeeList = async () => {
    const payload = {
      partnerName: getOrganisationDetailsData?.organisation?.partner_name[0]
    }
      try {
          const data= await getPartnerEmployees(payload, token);
          setEmployeeList(data?.employees)
        } catch (error) {
        } finally {
        }
    }

    useEffect(() => {
      getEmployeeList()
    }, [getOrganisationDetailsData])
  


  // table handling
  const licensesTable = [
    {
      id: 1,
      license_number: "RS25-XXXX-XXXX-XXXX",
      status: "Active",
      startDate: "2023-11-30",
      expiryDate: "2023-11-30",
      assignedTo: "Team Alpha",
      adminName: "Admin Name"
    },
    {
      id: 2,
      license_number: "RS25-XXXX-XXXX-XXXX",
      status: "Active",
      startDate: "2023-11-30",
      expiryDate: "2023-11-30",
      assignedTo: "Team Alpha",
      adminName: "Admin Name"
    },
    {
      id: 3,
      license_number: "RS25-XXXX-XXXX-XXXX",
      status: "Expired",
      startDate: "2023-11-30",
      expiryDate: "2023-11-30",
      assignedTo: "Team Alpha",
      adminName: "Admin Name"
    },
  ]

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [licenseCurrentPage, setLicenseCurrentPage] = useState(1)
  const pageSize = 10
  const totalItems = licensesTable.length
  const licensestotalItems = licenses?.length

  const columnsTable = [
    {
      header: "Sl No",
      accessor: "_id",
      cell: (value,row,index) => {
        return index + 1
      },
    },
    {
      header: "License Number",
      accessor: "licenseKey",
      cell: (value, row) => (
        <div className="text-sm font-medium text-gray-900 group-hover:text-red-600 transition-colors">{value}</div>
      ),
    },
    {
      header: "Start Date",
      accessor: "startDate",
      cell: (value) => (
        <div className="text-sm text-gray-600 flex items-center">
          <Calendar className="h-4 w-4 text-gray-400 mr-2" />
           {new Date(value).toLocaleDateString()}
        </div>
      ),
    },
    {
      header: "Expiry Date",
      accessor: "expiryDate",
      cell: (value) => (
        <div className="text-sm text-gray-600 flex items-center">
          <Calendar className="h-4 w-4 text-gray-400 mr-2" />
          {new Date(value).toLocaleDateString()}
        </div>
      ),
    },
    {
      header: "Status",
      accessor: "status",
      cell: (value) => (
        <span className={`py-1.5 text-sm font-medium text-center rounded-full ${getStatusColor(value)}`}>{value}</span>
      ),
    },
    
    {
      header: "Assigned To",
      accessor: "assignedTo",
      cell: (value) => (
        <span>{value ? value : "Unassigned"}</span>
      ),
    },
    {
      header: "Admin Name",
      accessor: "adminName",
    },
  ]


  const handlePageChange = (page) => {
    if(currentView === 'employees'){
      setCurrentPage(page)
    } else {
      setLicenseCurrentPage(page)
    }
  }


  ////

  const organization = {
    name: "Acme Corporation",
    type: "Technology",
    partner_name: "John Abc",
    no_of_docker_generated: "10",
    no_of_docker_downloaded: "05",
    agreementFile: "organization-agreement.pdf"
  };

  const employees = [
    { id: 1, name: "John Doe", position: "Software Engineer", department: "Engineering", joinDate: "2022-01-15", isAdmin:true },
    { id: 2, name: "Jane Smith", position: "Product Manager", department: "Product", joinDate: "2021-08-20", isAdmin:false },
    { id: 3, name: "Mike Johnson", position: "UX Designer", department: "Design", joinDate: "2022-03-10", isAdmin:false },
    { id: 4, name: "Sarah Williams", position: "Marketing Lead", department: "Marketing", joinDate: "2021-11-05", isAdmin:false },
  ];
// "employees": [
//         {
//             "_id": "67ee62250292ee1343127a00",
//             "organisation": "67eb8058223602bdc4396ee0",
//             "name": "testuser",
//             "email": "testuser123@gmail.com",
//             "company_admin": false,
//             "createdAt": "2025-04-03T10:25:41.876Z",
//             "updatedAt": "2025-04-03T10:25:41.876Z",
//             "__v": 0
//         },
  const columnsEmployeesTable = [
  {
    header: "Id",
    accessor: "_id",
  },
  {
    header: "Name",
    accessor: "name",
  },
  {
    header: "Email",
    accessor: "email",
  },
  {
    header: "Created Time",
    accessor: "createdAt",
    cell: (value) => value ? new Date(value).toLocaleDateString('en-GB') : "N/A",
  },
  {
    header: "Admin",
    accessor: "company_admin",
    cell: (_, row) => (row.company_admin ? "Yes" : "No"),
  },
  {
    header: "Actions",
    accessor: "actions",
    cell: (_, row) => (
     <button
        onClick={() => toggleAdmin(row.organisation.id, row._id,row.company_admin ? false : true)}
        className={`px-3 py-1 text-white rounded ${
          row.company_admin ? "bg-red-500 hover:bg-red-600" : "bg-blue-500 hover:bg-blue-600"
        }`}
      >
        {row.company_admin ? "Revoke Admin" : "Make Admin"}
      </button>
    ),
  },
];

const toggleAdmin = async (orgId, userId,action) => {
  try {
    const data = await makeEmployeeAdmin(orgId, userId,action, token)
    toast.success(data?.message || 'Admin made successfully')
    getEmployeeList()
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Failed to make admin')
  }
};

  const filteredEmployees = employeeList?.filter(employee => 
    employee?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    employee?.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredLicenses = licenses?.filter(license =>
    license?.licenseKey?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    license?.status?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCreateLicense = async () => {
    const payload = {
      organizationId: id,
      createdBy: userInfo?._id
    };
  
      try {
          await GenerateLicense(payload, token);
          toast.success('License generate successfully');
          getLicenses();
        } catch (error) {
          toast.error(error?.response?.data?.message || 'Failed to generate license');
        } finally {
          // setLoading(false);
        }
    }


    const getLicenses = async () => {
      try {
        const data = await getListLicenses(id, token);
        setLicenses(data);
      } catch (error) {
          toast.error(error?.response?.data?.message || 'Failed to get license');
      }
    }

    useEffect(()=>{
      if(isCompanyAdmin){
        getLicenses();
      }
    },[id])

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'text-green-600 bg-green-50';
      case 'expiring soon':
        return 'text-yellow-600 bg-yellow-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header Banner */}
      <div className="bg-gradient-to-r from-red-600 to-red-700 text-white">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-white/10 rounded-2xl backdrop-blur-sm">
              <Building2 className="h-8 w-8" />
            </div>
            <div>
              <h1 className="text-3xl font-bold tracking-tight capitalize">
                {/* {organization.name} */}
                {getOrganisationDetailsData?.organisation?.partner_name || "partner name"}
              </h1>
              <p className="text-red-100 mt-1 flex items-center">
                <span className="mr-3 capitalize">
                  {/* {organization.type} */}
                  {getOrganisationDetailsData?.organisation?.name || "organisation name"}
                </span>
                {/* <span className="ml-3 flex items-center">
                  <MapPin className="h-4 w-4 mr-1" />
                  {organization.location}
                </span> */}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 space-y-8">
        {/* Organization Details Card */}
        <div className="bg-white rounded-2xl shadow-lg shadow-gray-100/50 border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8">
            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                <Building2 className="h-6 w-6 text-red-600 mr-3" />
                Organization Details
              </h2>
              <div className="space-y-4 bg-gray-50/50 rounded-xl p-6 border border-gray-100">
                <div className="flex items-center group transition-all">
                  <span className="text-gray-500 w-32">Organisation Name</span>
                  <div className="flex items-center">
                    <Handshake className="h-4 w-4 text-red-500 mr-2" />
                    <span className="text-gray-900 font-medium group-hover:text-red-600 transition-colors capitalize">
                      {getOrganisationDetailsData?.organisation?.name || "name"}
                    </span>
                  </div>
                </div>
                <div className="flex items-center group transition-all">
                  <span className="text-gray-500 w-32">Dockers</span>
                  <div className="flex items-center">
                    <GrDocker className="h-4 w-4 text-red-500 mr-2" />
                    <span className="text-gray-900 font-medium group-hover:text-red-600 transition-colors">
                      Generated: {getOrganisationDetailsData?.generateCount || 0}
                      {/* {organization.no_of_docker_generated} */}
                      <br/>
                      {/* Downloaded: 0 */}
                      {/* {organization.no_of_docker_downloaded} */}
                    </span>
                  </div>
                </div>
                <div className="flex items-center group transition-all">
                  <span className="text-gray-500 w-32">Total Licenses</span>
                  <div className="flex items-center">
                    <FilePlus2 className="h-4 w-4 text-red-500 mr-2" />
                    <span className="text-gray-900 font-medium group-hover:text-red-600 transition-colors">
                      {licenses?.length || 0}
                    </span>
                  </div>
                </div>
              </div>
              <button onClick={handleCreateLicense} className="flex items-center gap-2 px-4 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors">
                <CircuitBoard />
                Generate License
              </button>
            </div>

            <div className="space-y-6">
              <h2 className="text-xl font-semibold text-gray-900 flex items-center">
                <FileText className="h-6 w-6 text-red-600 mr-3" />
                Agreement Document
              </h2>
              <div className="bg-white rounded-xl border-2 border-red-100 p-6 hover:border-red-200 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="p-3 bg-red-50 rounded-lg">
                      <FileText className="h-6 w-6 text-red-600" />
                    </div>
                    <span className="ml-4 text-gray-900 font-medium">Organization Agreement</span>
                  </div>
                  <a
                    href={getOrganisationDetailsData?.organisation?.agreement_doc}
                    target='_blank'
                    download className="flex items-center px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors group">
                    <Download className="h-4 w-4 mr-2 group-hover:scale-110 transition-transform" />
                    <span className="font-medium">Download</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-2xl shadow-lg shadow-gray-100/50 border border-gray-100 overflow-hidden">
          <div className="px-8 py-6 border-b border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
              <div className="flex items-center space-x-4">
                <div className="p-2 bg-red-50 rounded-lg">
                  {currentView === 'employees' ? (
                    <Users className="h-5 w-5 text-red-600" />
                  ) : (
                    <License className="h-5 w-5 text-red-600" />
                  )}
                </div>
                <div className="relative">
                  <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="flex items-center space-x-2 text-xl font-semibold text-gray-900 hover:text-red-600 transition-colors focus:outline-none"
                  >
                    <span>{currentView === 'employees' ? 'Employees' : 'Licenses'}</span>
                    <ChevronDown className={`h-5 w-5 transition-transform ${isDropdownOpen ? 'transform rotate-180' : ''}`} />
                  </button>
                  {isDropdownOpen && (
                    <div className="absolute z-10 mt-2 w-48 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="py-1">
                        <button
                          onClick={() => {
                            setCurrentView('employees');
                            setIsDropdownOpen(false);
                          }}
                          className={`block px-4 py-2 text-sm w-full text-left ${
                            currentView === 'employees' ? 'bg-red-50 text-red-600' : 'text-gray-700 hover:bg-gray-50'
                          }`}
                        >
                          Employees
                        </button>
                        <button
                          onClick={() => {
                            setCurrentView('licenses');
                            setIsDropdownOpen(false);
                          }}
                          className={`block px-4 py-2 text-sm w-full text-left ${
                            currentView === 'licenses' ? 'bg-red-50 text-red-600' : 'text-gray-700 hover:bg-gray-50'
                          }`}
                        >
                          Licenses
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between sm:justify-end space-x-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder={`Search ${currentView}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  />
                  <Search className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                </div>
                <span className="bg-red-50 text-red-600 text-sm font-medium px-4 py-1.5 rounded-full">
                  {currentView === 'employees' ? filteredEmployees?.length : filteredLicenses?.length} Total
                </span>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto">
            {currentView === 'employees' ? (
              <Table
                columns={columnsEmployeesTable}
                data={filteredEmployees}
                pagination={{
                  currentPage,
                  pageSize,
                  totalItems,
                  onPageChange: handlePageChange,
                }}
                className="bg-white rounded-lg shadow"
              />
            ) : (
              <Table
                columns={columnsTable}
                data={filteredLicenses}
                pagination={{
                  currentPage: licenseCurrentPage,
                  pageSize,
                  totalItems: licensestotalItems,
                  onPageChange: handlePageChange,
                }}
                className="bg-white rounded-lg shadow"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrganisationDetails;